import React from 'react';
import classNames from 'classnames';
import {toLower} from 'lodash';

export default function ({skill_data, selectSkill}) {
    const onClick = () => {
        selectSkill(skill_data.code);
    }

    const class_names = classNames(
        'constellation-star',
        'flex-column flex-v-center',
        toLower(skill_data.code.replace(' ', '-'))
    );

    return (
        <div className={class_names}>
            <div className="constellation-star-relative">
                <div className={`constellation-star-name color-${skill_data.tier}`}>
                    {skill_data.name}
                </div>
            </div>
            <div className={`constellation-star-circle border-${skill_data.tier} box-shadow-${skill_data.tier} flex-row flex-vh-center`} onClick={onClick}>
                <img src={skill_data.image_url} />
            </div>
        </div>
    );
}